import { render, staticRenderFns } from "./manageBrandName.vue?vue&type=template&id=377145bf&scoped=true&"
import script from "./manageBrandName.vue?vue&type=script&lang=js&"
export * from "./manageBrandName.vue?vue&type=script&lang=js&"
import style0 from "./manageBrandName.vue?vue&type=style&index=0&id=377145bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377145bf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDialog,VIcon,VSimpleTable})
